import React from "react";

import { Route, Switch } from "react-router-dom";

import LoginAdmin from "./LoginAdmin";
import LoginLayout from "./LoginLayout";
import NewPassword from "./NewPassword";
import ResetPassword from "./ResetPassword";
import Notifier from "../common/tools/Notifier";
import { LOGIN_ROUTE } from "../routes/routes";

import type { JSX } from "react";

interface LoginAdminUIProps {
  match: { url: string };
}

export function LoginAdminUI({ match }: LoginAdminUIProps): JSX.Element {
  return (
    <LoginLayout data-testid="LoginAdminRoot">
      <Notifier />
      <div className="beamerTrigger hidden" data-testid="beamerTrigger" />
      <Switch>
        <Route
          exact
          path={`${LOGIN_ROUTE}/resetpassword`}
          render={() => (
            <ResetPassword
              redirectTo={match.url}
              resetRoute={`${LOGIN_ROUTE}/resetpassword/new`}
            />
          )}
        />
        <Route
          exact
          path={`${LOGIN_ROUTE}/resetpassword/new`}
          render={() => <NewPassword redirectTo={match.url} />}
        />
        <Route
          path={match.url}
          render={() => (
            <LoginAdmin
              pathToResetPassword={`${LOGIN_ROUTE}/resetpassword`}
              redirectTo="/"
            />
          )}
        />
      </Switch>
    </LoginLayout>
  );
}

export default LoginAdminUI;
